const isvmi = [
  { id: "Y", label: "Y" },
  { id: "N", label: "N" }
]

export const getIsvmiById = id => isvmi.find(isvmi => isvmi.id === id)
export const allIsvmi = isvmi.map(({ id }) => id)

export default isvmi
